const getStudyFullYear = (date = new Date()) => {
  const year = date.getFullYear();
  const cutoffDate = new Date(year, 2, 1); // 1 марта

  return date < cutoffDate ? year - 1 : year;
};

  export default getStudyFullYear;